module.exports = __webpack_public_path__ + "img/smockup.82bb6baf.jpg";